import { render, staticRenderFns } from "./YoutubeSVG.vue?vue&type=template&id=6c2bbee6&"
import script from "./YoutubeSVG.vue?vue&type=script&lang=js&"
export * from "./YoutubeSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports